import { Group, Popover, Box } from '@mantine/core';
import { FC, useEffect, useState } from 'react';
import ReactGPicker from 'react-gcolor-picker';
import { useDebouncedCallback } from 'use-debounce';
import { ThemeText } from '../ThemeText';

interface Props {
  initialGradient: string;
  label: string;
  onChange: (val: string) => unknown;
}

const GradientPicker: FC<Props> = ({ initialGradient, label, onChange }) => {
  const [gradient, setGradient] = useState(initialGradient);

  useEffect(() => {
    if (gradient !== initialGradient) {
      setGradient(initialGradient);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialGradient]);

  useEffect(() => {
    if (gradient !== initialGradient) {
      debouncedOnChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradient]);

  const debouncedOnChange = useDebouncedCallback(() => onChange(gradient), 1000);

  return (
    <Group>
      <Popover>
        <Popover.Target>
          <Box
            sx={(theme) => ({
              background: gradient,
              width: 25,
              height: 25,
              borderRadius: 4,
              boxShadow: 'rgba(0, 0, 0, .1) 0px 0px 0px 1px inset,rgb(0, 0, 0, .15) 0px 0px 4px inset',
              cursor: 'pointer',
              border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[0] : 'none'}`,
            })}
          />
        </Popover.Target>
        <Popover.Dropdown>
          <ReactGPicker gradient value={gradient} onChange={setGradient} />
        </Popover.Dropdown>
      </Popover>
      <ThemeText size="xs">{label}</ThemeText>
    </Group>
  );
};

export default GradientPicker;
